<h2 mat-dialog-title class="dialog-title">{{isEditMode ? 'Edytuj cennik' : 'Nowy cennik'}}</h2>
<hr class="title-separator" />

<mat-dialog-content class="dialog-content">
    <div class="date-row">
        <mat-form-field class="date-field">
            <mat-label>Ważny od</mat-label>
            <input matInput [matDatepicker]="validFromPicker" [(ngModel)]="validFrom" />
            <mat-datepicker-toggle matSuffix [for]="validFromPicker"></mat-datepicker-toggle>
            <mat-datepicker #validFromPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="date-field">
            <mat-label>Ważny do</mat-label>
            <input matInput [matDatepicker]="validToPicker" [(ngModel)]="validTo" />
            <mat-datepicker-toggle matSuffix [for]="validToPicker"></mat-datepicker-toggle>
            <mat-datepicker #validToPicker></mat-datepicker>
        </mat-form-field>
    </div>

    <div class="label section-label">Taryfy</div>
    <table class="tariffs-edit-table">
        <thead>
            <tr>
                <th>Tier</th>
                <th>Nazwa Taryfy</th>
                <th>Cena taryfy</th>
                <th>Zamówienia</th>
                <th>Produkty</th>
                <th>Aukcje</th>
                <th>Przesyłki</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            @for (tariff of tariffs; track tariff) {
            <tr>
                <td class="tier-cell">{{tariff.tier}}</td>
                <td><input type="text" class="name-input" [(ngModel)]="tariff.name" /></td>
                <td><input type="text" class="price-input" onlyNumbers [(ngModel)]="tariff.price" /></td>
                <td>
                    <div class="range-cell">
                        <input type="text" onlyNumbers [(ngModel)]="tariff.orders.from" />
                        <span class="range-separator">-</span>
                        <input type="text" onlyNumbers [(ngModel)]="tariff.orders.to" />
                    </div>
                </td>
                <td>
                    <div class="range-cell">
                        <input type="text" onlyNumbers [(ngModel)]="tariff.products.from" />
                        <span class="range-separator">-</span>
                        <input type="text" onlyNumbers [(ngModel)]="tariff.products.to" />
                    </div>
                </td>
                <td>
                    <div class="range-cell">
                        <input type="text" onlyNumbers [(ngModel)]="tariff.auctions.from" />
                        <span class="range-separator">-</span>
                        <input type="text" onlyNumbers [(ngModel)]="tariff.auctions.to" />
                    </div>
                </td>
                <td>
                    <div class="range-cell">
                        <input type="text" onlyNumbers [(ngModel)]="tariff.shipments.from" />
                        <span class="range-separator">-</span>
                        <input type="text" onlyNumbers [(ngModel)]="tariff.shipments.to" />
                    </div>
                </td>
                <td>
                    <button type="button" class="remove-tariff-btn" (click)="removeTariff(tariff)" aria-label="Usuń taryfę">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>
                    </button>
                </td>
            </tr>
            }
        </tbody>
    </table>
    <button mat-stroked-button type="button" (click)="addTariff()">+ Dodaj taryfę</button>

    <div class="section-title">Ceny za dodatkową jednostkę</div>
    <div class="extra-prices-row">
        <mat-form-field class="extra-price-field">
            <mat-label>Zamówienia</mat-label>
            <input matInput type="number" [(ngModel)]="extraPrices.orders" />
        </mat-form-field>
        <mat-form-field class="extra-price-field">
            <mat-label>Produkty</mat-label>
            <input matInput type="number" [(ngModel)]="extraPrices.products" />
        </mat-form-field>
        <mat-form-field class="extra-price-field">
            <mat-label>Aukcje</mat-label>
            <input matInput type="number" [(ngModel)]="extraPrices.auctions" />
        </mat-form-field>
        <mat-form-field class="extra-price-field">
            <mat-label>Przesyłki</mat-label>
            <input matInput type="number" [(ngModel)]="extraPrices.shipments" />
        </mat-form-field>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button matButton (click)="closeDialog()">Anuluj</button>
    <button mat-flat-button color="primary" cdkFocusInitial (click)="save()" [disabled]="!isValid()">Zapisz</button>
</mat-dialog-actions>
